import React from "react";

import { Field, Inputs } from "2g-form";

import { useToLocaleDateFull } from "b2b/i18n";
import useMessages from "./i18n/useMessages";
import useRezervaceVytvoreniDatumOd from "./hooks/useRezervaceVytvoreniDatumOd";

export function RezervaceVytvoreniDatumOd() {
  const { datumOdLabel } = useMessages();
  const formatter = useToLocaleDateFull();

  const { visible } = useRezervaceVytvoreniDatumOd();

  return visible ? (
    <Field
      label={datumOdLabel()}
      component={Inputs.DateTimeWidget}
      date
      milliseconds
      path="datumOd"
      formatterDate={formatter}
    />
  ) : undefined;
}

RezervaceVytvoreniDatumOd.propTypes = {};

export default React.memo(RezervaceVytvoreniDatumOd);
